import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

import BaseLayout from '@zego/layouts/BaseLayout';
import { primaryColor, unit } from '@zego/theme';
import Tint from '@zego/themes/Tint';

import View from '@zego/components/atoms/View';
import ContentContainer from '@zego/components/ContentContainer';
import PurchaseFlowFooter from '@zego/components/PurchaseFlowFooter';
import SimpleHeader from '@zego/components/SimpleHeader';
import TrustPilotTestimonial from '@zego/components/TrustPilotTestimonial';

class PurchaseLayout extends React.PureComponent {
  render() {
    const {
      children,
      viewer,
      hideReview,
      useContentContainer = true,
      ...props
    } = this.props;
    return (
      <BaseLayout
        viewer={viewer}
        darkContent
        hideFooter
        header={<SimpleHeader />}
        {...props}
      >
        <Tint color={primaryColor(8)}>
          <>
            {useContentContainer ? (
              <ContentContainer
                css={{
                  marginTop: unit(6),
                  marginBottom: unit(10),
                  minHeight: hideReview ? 'initial' : `calc(100vh - 25.4rem)`,
                }}
              >
                {children}
              </ContentContainer>
            ) : (
              <View>{children}</View>
            )}
            {hideReview ? null : (
              <PurchaseFlowFooter
                customerReview={<TrustPilotTestimonial.Neil />}
              />
            )}
          </>
        </Tint>
      </BaseLayout>
    );
  }
}

export default createFragmentContainer(PurchaseLayout, {
  viewer: graphql`
    fragment PurchaseLayout_viewer on Viewer
      @argumentDefinitions(country: { type: "String!" }) {
      ...BaseLayout_viewer @arguments(country: $country)
    }
  `,
});
